module.exports = __webpack_public_path__ + "static/media/university_list.5960251f.png";